module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-natural-brushed-4041-scale.e541001e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-natural-brushed-4041-scale.jpg
// module id = 1119
// module chunks = 37